import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isOpen: false,
  team: {},
};

const teamSlice = createSlice({
  name: "team",
  initialState,
  reducers: {
    openModal: (state, action) => {
      state.isOpen = true;
      state.team = action.payload;
    },
    closeModal: (state, action) => {
      state.isOpen = false;
    },
  },
});
export default teamSlice.reducer;
export const { openModal, closeModal } = teamSlice.actions;
